import React from 'react';
import { Box, Flex, Center } from '@chakra-ui/react';

interface IMFAStepProps {
  number: number;
  title: React.ReactNode;
  children: React.ReactNode;
}

const MFAStep = (props: IMFAStepProps) => {
  const { number, title, children } = props;

  return (
    <>
      <Flex my={6}>
        <Center
          width={10}
          height={10}
          flex="0 0 2.5rem"
          bgColor={'chakra-subtle-bg'}
          borderRadius={'full'}
          fontWeight={'medium'}
          fontSize={'xl'}
          display={{ base: 'none', sm: 'flex' }}
          ml={2}
          mr={6}
        >
          {number}
        </Center>

        <Box pt={2}>
          <Box fontWeight={'medium'} fontSize={'xl'} mb={4} lineHeight={6}>
            {title}
          </Box>

          <Box>{children}</Box>
        </Box>
      </Flex>
    </>
  );
};

export { MFAStep };
